<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { useAR } from '@/store/Pinia/useAR.store'

  import { ref, onMounted } from 'vue'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const arStore = useAR()

  onMounted(() => {
    modal.value = new Modal('#modal-request-in-progress', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  defineExpose({ show, hide })
</script>

<template>
  <div id="modal-request-in-progress" class="modal modal-md fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3">
          <h5 class="modal-title">Solicitação em andamento</h5>
        </div>
        <div class="modal-body py-3">
          <img alt="sucesso" src="../assets/computer-with-clock.svg" />

          <p class="fs-6 text-start mt-4">
            Sua solicitação está em <strong>andamento.</strong>
          </p>

          <p class="fs-6 text-start mt-4">
            Fique tranquilo!
            <strong>Você será notificado por e-mail</strong> quando sua
            solicitação for concluída e poderá prosseguir com a instalação.
          </p>

          <div class="contact-wrapper">
            <div class="contact py-3">
              <div class="contact-item">
                <span class="color--primary fw-600">
                  Ficou alguma dúvida?
                </span>
              </div>
              <div class="contact-item">
                <icon-component class="icon mx-1" name="phone" />
                <span>{{ arStore.$state.arData.foneAR }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer py-3">
          <router-link to="/" class="btn btn-primary" type="button">
            <icon-component name="house" class="me-2" />
            Página inicial
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .contact-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    width: 100%;
  }
  .contact {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 1rem;
    border: 1px solid #e6e7ec;
    border-radius: 10px;
  }
  .contact-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }
</style>
